<template>
  <div>
    <report-base
      title="Arrivals"
      table-class="analytics-tables--arrivals"
      subject="arrival"
      :items="arrivals"
      :fields="fields"
      :is-loading="loading"
      @reload="loadData"
    />
  </div>
</template>

<script>
import AnalyticsMixin from './mixin';

export default {
  name: 'analytics-arrivals',

  mixins: [
    AnalyticsMixin
  ],

  data() {
    return {
      arrivals: [],
      fields: [
        {
          key: 'booking_name',
          label: 'Booking Name',
          sortable: true,
        },
        {
          key: 'guest_names',
          label: 'Guest Name',
          sortable: true,
          thStyle: 'width: 200px'
        },
        {
          key: 'booking_number',
          label: 'Booking Number',
          sortable: true,
          thStyle: 'width: 150px'
        },
        {
          key: 'booking_rooms',
          label: 'Room',
          sortable: false,
          thStyle: 'width: 150px'
        },
        {
          key: 'booking_room_types',
          label: 'Room Category',
          sortable: false,
          thStyle: 'width: 150px'
        },
        {
          key: 'check_in_at',
          label: 'Check-in',
          sortable: true,
          thStyle: 'width: 165px'
        },
        {
          key: 'check_out_at',
          label: 'Check-out',
          sortable: true,
          thStyle: 'width: 165px'
        },
        {
          key: 'night_count',
          label: 'No. Nights',
          sortable: true,
          thStyle: 'width: 100px'
        },
        {
          key: 'booking_notes',
          label: 'Notes',
          sortable: true,
          thStyle: 'width: 200px'
        },
      ]
    };
  },

  mounted() {
    this.loadData();
  },

  methods: {
    loadData () {
      this.loading = true;

      this.fetchData('arrival')
        .then(res => {
          this.arrivals = res.data
            .map(item => {
              item.check_in_at = this.formatDate(item.check_in_at);
              item.check_out_at = this.formatDate(item.check_out_at);

              return item;
            });
        })
        .catch(err => {
          this.errorNotification('Failed to fetch booking report!');
        })
        .finally(()=> {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
  .analytics-tables--arrivals {
    table {
      min-width: 1500px !important;
    }
  }
</style>
